import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

export const FooterRoot = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #f0f6ff 60%, #e3ecfa 100%)',
  marginTop: theme.spacing(8),
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  boxShadow: '0 -2px 16px 0 rgba(0,0,0,0.04)',
}));

export const FooterContainer = styled(Container)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  background: 'rgba(255,255,255,0.85)',
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.03)',
  padding: theme.spacing(4, 2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 3),
  },
}));

export const CopyrightRow = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.text.secondary,
  textAlign: 'center',
  fontSize: theme.typography.body2.fontSize,
})); 